export { ExactEvmSchemeV1 } from "../exact/v1";

export const NETWORKS: string[] = [
  "abstract",
  "abstract-testnet",
  "base-sepolia",
  "base",
  "avalanche-fuji",
  "avalanche",
  "iotex",
  "sei",
  "sei-testnet",
  "polygon",
  "polygon-amoy",
  "peaq",
  "story",
  "educhain",
  "xLayer",
  "bsc",
  "kite",
  "bscTest",
  "skale-base-sepolia",
];
